import { render, staticRenderFns } from "./FreePeriodExtension.vue?vue&type=template&id=4fc7833d&scoped=true&"
import script from "./FreePeriodExtension.vue?vue&type=script&lang=js&"
export * from "./FreePeriodExtension.vue?vue&type=script&lang=js&"
import style0 from "./FreePeriodExtension.vue?vue&type=style&index=0&id=4fc7833d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc7833d",
  null
  
)

export default component.exports